import React, { useState, useEffect } from "react";
import TableComponent from "./TableComponent";
import Preloader from "../shared/PreLoaders";

const ActivityLogTable = () => {
  const [data, setData] = useState([]); // State for storing API data
  const [loading, setLoading] = useState(true); // State for showing loading spinner
  const [error, setError] = useState(null); // State for handling errors
  const Api = process.env.REACT_APP_API;

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${Api}/api/activity-log`);
        if (!response.ok) {
          throw new Error("Failed to fetch activity logs");
        }
        const result = await response.json();
        setData(result); // Set fetched data to the state
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const column = [
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: "User Name",
      field: "userId.name",
    },
    {
      headerName: "Activity",
      field: "activity",
    },
    {
      headerName: "Page",
      field: "page",
    },
    {
      headerName: "Time",
      field: "timestamp",
    },
  ];

  if (error) {
    return <p style={{ color: "red" }}>Error: {error}</p>;
  }

  return (
    <div className="table-responsive">
      <Preloader loading={loading} />
      <TableComponent data={data} columns={column} />
      {data.length === 0 && (
        <p style={{ textAlign: "center" }}>No data available</p>
      )}
    </div>
  );
};

export default ActivityLogTable;
